import { useState } from "react";
import About from "./Tabs/About";
import Employment from "./Tabs/Employment";
import Education from "./Tabs/Education";
import RecruiterNotes from "./Tabs/RecruiterNotes";
import ProposeFor from "./Tabs/ProposeFor";
import SimilarCandidates from "./Tabs/SimilarCandidates";
import RecommendHistory from "./Tabs/RecommendHistory";
import { useAuthContext } from "../../../context/AuthContext";

const CustomTabs = (props) => {
  const { userDetails } = useAuthContext();
  const user_primary_role = JSON.parse(userDetails).user_primary_role;

  const { resourceDetails, displayView } = props;

  const Summary = () => (
    <About bio={resourceDetails?.profile_details?.profile_bio} />
  );
  const Experience = () => (
    <Employment
      employmentDetails={resourceDetails?.employment_details}
      displayView={displayView}
    />
  );
  const EducationTab = () => (
    <Education
      educationDetails={resourceDetails?.education_details}
      displayView={displayView}
    />
  );
  const RecruiterNotesTab = () => (
    <RecruiterNotes
      recruiterNotes={resourceDetails?.recruiter_notes}
      resourceSlug={resourceDetails?.profile_details?.user_slug}
    />
  );
  const Opportunities = () => (
    <ProposeFor resourceSlug={resourceDetails?.profile_details?.user_slug} />
  );
  const SimilarCandidatesTab = () => (
    <SimilarCandidates
      resourceSlug={resourceDetails?.profile_details?.user_slug}
      actualProfileName={resourceDetails?.profile_details?.profile_name}
    />
  );
  const Recommendations = () => (
    <RecommendHistory
      resourceSlug={resourceDetails?.profile_details?.user_slug}
    />
  );

  // Always visible tabs
  const allTabComponents = {
    Summary,
    Experience,
    Education: EducationTab,
  };

  // Conditionally include recruiter-only tabs
  if (user_primary_role === "2") {
    allTabComponents["Recruiter Notes"] = RecruiterNotesTab;
    allTabComponents["Opportunities"] = Opportunities;
    allTabComponents["Similar Candidates"] = SimilarCandidatesTab;
    allTabComponents["Recommendations"] = Recommendations;
  }

  const filteredTabComponents =
    displayView === "default"
      ? allTabComponents
      : Object.fromEntries(
          Object.entries(allTabComponents).filter(([key]) =>
            ["Summary", "Experience", "Education"].includes(key)
          )
        );

  const tabNames = Object.keys(filteredTabComponents);
  const [activeTab, setActiveTab] = useState(tabNames[0]);
  const ActiveComponent = filteredTabComponents[activeTab];

  return (
    <div>
      <div className="d-flex gap-2 p-2 rounded border bg-light overflow-auto">
        {tabNames.map((tab) => (
          <button
            key={tab}
            className={`btn px-3 py-1 rounded-pill fw-normal btn-sm ${
              activeTab === tab ? "btn-primary text-white" : "text-dark"
            }`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      <div className="mt-4">
        {ActiveComponent ? (
          <ActiveComponent />
        ) : (
          <div>No content available.</div>
        )}
      </div>
    </div>
  );
};

export default CustomTabs;
